<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-table-list" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary"  @click="gpath_career_typeAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-2">
                  <b-form-input v-model="filter" placeholder="Search" @input="gpath_career_typeList(filter)" />
              </b-col>
            <b-col class="mb-2 col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <multiselect
                    v-model="selectedCareerName"
                    :options="gpath_career_filter_list['name']"
                    :multiple="false"
                    :preserve-search="true"
                    placeholder="Choose Career Role Name"
                    label="name"
                    track-by="name"
                    class="multiselect_group"
                    @input="onCareerNameInput"
                />
            </b-col>
            <!-- GPath Producat Id -->
            <b-col class="mb-2 col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <select v-model="whereFilter.pdt_id" class="form-control" title="session states" @change="setFilters">
                    <option value="">Select Product Id</option>
                    <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id" >
                    {{ item.id }}
                    </option>
                </select>
            </b-col><!-- GPath Producat Id -->
        </b-row>
        </b-col>
        <b-col v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3">
            <VueJsonToCsv :json-data="gpath_career_typeObjList" csv-title="gpath_career_type_list" v-if="gpath_career_typeObjList && gpath_career_typeObjList.length">
              <i class="fa-solid fa-file-csv Download_button" title="Download CSV"></i>
            </VueJsonToCsv>
            <CsvDownload :propModuleFile="cvModuleFile" class="Download_button" />
            <CsvUpload :propModulePrefix="cvModulePrefix" class="Download_button"  />
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="gpath_career_typeObjList && gpath_career_typeObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpath_career_typeObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(action)="data">
                <b-button variant="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="gpath_career_typeEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0"></i></b-button>
                <b-button variant="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showGPathCareertypeDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
              </template>

              <template v-slot:cell(career_type)="data">
                {{ data.item.name == data.item.name2 ? "Single" : "Combo" }}<br>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>

          <b-col sm="7" md="8" class="my-1">
            <b-btn v-if="showLoadMoreBtn" variant="primary" @click="loadMoreData">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
                v-model="currentBatchNo"
                :total-rows="totalRows"
                :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelGPathCareertypeAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <GPathCareerRoleAdd :propOpenedInModal="true" @emitCloseGPathCareertypeAddModal="closeGPathCareertypeAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_typeAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareertypeAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelGPathCareertypeEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <GPathCareerRoleEdit :propOpenedInModal="true" :propGPathCareertypeObj="gpath_career_roleEditObj" @emitCloseGPathCareertypeEditModal="closeGPathCareertypeEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_typeEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareertypeEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelGPathCareertypeDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelGPathCareertypeDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_career_typeDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { GPathCareerType } from "../../../FackApi/api/GPathCareerType.js"
import GPathCareerRoleAdd from "./GPathCareerRoleAdd.vue"
import GPathCareerRoleEdit from "./GPathCareerRoleEdit.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import Multiselect from "vue-multiselect"

export default {
  name: "GPathCareertypeList",
  components: {
    GPathCareerRoleAdd,
    GPathCareerRoleEdit,
    CsvDownload,
    CsvUpload,
    Multiselect
  },
  data () {
    return {
      apiName: "gpath_career_type_list",
      cvModuleFile: "gpath_career_type",
      cvModulePrefix: "GPCT",
      cvCardTitle: "GPath Career Roles Types",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPath Career Roles Type",
      cvAddModalHeader: "Add GPath Career Roles Type",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPath Career Type Roles List",
      showModelGPathCareertypeAdd: false,
      showModelGPathCareertypeEdit: false,
      showModelGPathCareertypeDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "action", key: "action", class: "text-left align-text-top", sortable: true },
        { label: "name", key: "name", class: "text-left align-text-top", sortable: true },
        { label: "name2", key: "name2", class: "text-left align-text-top", sortable: true },
        { label: "career type", key: "career_type", class: "text-left align-text-top", sortable: false },
        { label: "title", key: "title", class: "text-left align-text-top", sortable: true },
        { label: "detail", key: "detail", class: "text-left align-text-top", sortable: true },
        { label: "url", key: "url", class: "text-left align-text-top", sortable: true }
      ],
      gpath_career_typeObjList: [],
      gpath_career_roleEditObj: null,
      gpath_career_filter_list: {
        name: []
      },
      filter: "",
      pdt_id: "",
      filterOn: [],
      totalRows: 1,
      currentBatchNo: 1,
      dataPerPage: 15,
      delObj: null,
      gpcPdtIdList: [],
      selectedCareerName: null,
      whereFilter: {
        isAdminPanel: true,
        name: "",
        pdt_id: "APPGPATHPRODUCTID"
      },
      showLoadMoreBtn: false,
      assessmentObjList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"] || {}
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    try {
      await this.gpath_career_filter("name")
      await this.gpathsproductIdListGet()
      await this.gpath_career_typeList()
    }
    catch (e) {
      console.error("Error in mounted hooks setup:", e)
    }
  },
  methods: {
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo++
      this.gpath_career_typeList(true)
    },
    /**
     * set Filters
     */
    async setFilters () {
      this.gpath_career_typeList()
    },
    /**
     * onCareerNameInput
     */

    onCareerNameInput (selectedOption) {
      this.whereFilter.name = selectedOption ? selectedOption.name : ""
      this.setFilters()
    },
    /**
     * gpath_career_typeList
     */
    async gpath_career_typeList (loadViaLoadMore = false, searchString = null) {
      this.showLoadMoreBtn = true
      try {
        let filter = {}
        if (searchString && searchString.length) {
          filter.searchString = searchString
        }

        filter.currentBatchNo = this.currentBatchNo
        filter.dataPerPage = this.dataPerPage
        filter.pdt_id = this.whereFilter.pdt_id
        let combinedFilter = {
          name: this.$route.params.name || this.whereFilter.name || "",
          ...filter
        }

        let gpathCareerTypeListResp = await GPathCareerType.gpath_career_roleList(this, "", combinedFilter)

        if (gpathCareerTypeListResp && gpathCareerTypeListResp.resp_status) {
          const gpathCareerTypeList = gpathCareerTypeListResp.resp_data.data || []

          if (loadViaLoadMore && this.gpath_career_typeObjList) {
            this.gpath_career_typeObjList = [...this.gpath_career_typeObjList, ...gpathCareerTypeList]
          }
          else {
            this.gpath_career_typeObjList = gpathCareerTypeList
            this.gpcTypePdtIdList = this.gpath_career_typeObjList.map(gpc => ({
              id: gpc.gpc_pdt_id
            }))
          }

          this.totalRows = gpathCareerTypeListResp.resp_data.count || this.gpath_career_typeObjList.length
          this.showLoadMoreBtn = gpathCareerTypeList.length >= this.dataPerPage
        }
        else {
          this.showLoadMoreBtn = false
          this.toastMsg = gpathCareerTypeListResp ? gpathCareerTypeListResp.resp_msg : "Failed to load data"
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        this.showLoadMoreBtn = false
        console.error("Exception occurred at gpath_career_type_list():", err)
      }
    },
    /**
     * gpath_career_typeAdd
     */
    gpath_career_typeAdd (type) {
      this.showModelGPathCareertypeAdd = true
    },
    /**
     * gpath_career_typeEdit
     */
    gpath_career_typeEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_type_edit/" + this.gpath_career_typeEditObj.gpct_id)
        }
        else {
          this.gpath_career_roleEditObj = item
          this.showModelGPathCareertypeEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_typeEdit() and Exception:", err.message)
      }
    },
    /**
     * showGPathCareertypeDeleteDialog
     */
    showGPathCareertypeDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathCareertypeDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathCareertypeDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_typeDelete
     */
    async gpath_career_typeDelete () {
      try {
        let gpathCareerTypeDelResp = await GPathCareerType.gpath_career_typeDelete(this, this.delObj.gpct_id)
        await ApiResponse.responseMessageDisplay(this, gpathCareerTypeDelResp)

        if (gpathCareerTypeDelResp && !gpathCareerTypeDelResp) {
          this.showModelGPathCareertypeDelete = false
          return false
        }

        let index = this.gpath_career_typeObjList.indexOf(this.delObj)
        this.gpath_career_typeObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelGPathCareertypeDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_typeDelete() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareertypeAddModal
     */
    closeGPathCareertypeAddModal (gpathCareerTypeAddData) {
      try {
        if (gpathCareerTypeAddData) {
          if (this.gpath_career_typeObjList && this.gpath_career_typeObjList.length >= 1) {
            let gpathCareerTypeObjLength = this.gpath_career_typeObjList.length
            let lastId = this.gpath_career_typeObjList[gpathCareerTypeObjLength - 1]["id"]
            gpathCareerTypeAddData.id = lastId + 1
          }
          else {
            this.gpath_career_typeObjList = []
            gpathCareerTypeAddData.id = 11111
          }

          gpathCareerTypeAddData.created_on = moment()
          this.gpath_career_typeObjList.unshift(gpathCareerTypeAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelGPathCareertypeAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_career_typeAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareertypeEditModal
     */
    closeGPathCareertypeEditModal () {
      try {
        this.showModelGPathCareertypeEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeGPathCareertypeEditModal() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_filter
    */
    async gpath_career_filter (filterName = null) {
      if (!filterName) return
      try {
        let gpathCareerFilterListResp = await GPathCareerType.gpath_career_filter(this, filterName)
        if (gpathCareerFilterListResp && gpathCareerFilterListResp.resp_status && gpathCareerFilterListResp.resp_data) {
          const incomingData = gpathCareerFilterListResp.resp_data.data || gpathCareerFilterListResp.resp_data
          this.gpath_career_filter_list[filterName] = Array.isArray(incomingData)
            ? incomingData
            : []
        }
        else {
          this.gpath_career_filter_list[filterName] = []
          this.toastMsg = gpathCareerFilterListResp ? gpathCareerFilterListResp.resp_msg : "Error loading filter structural data"
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        this.gpath_career_filter_list[filterName] = []
        console.log("Exception occurred at gpath_roadmap_filter_list() and Exception:", err.message)
      }
    },
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList || !gpaList.resp_status) {
          if (gpaList) ApiResponse.responseMessageDisplay(this, gpaList)
          this.gpcPdtIdList = []
          return
        }
        this.assessmentObjList = gpaList.resp_data.data || []
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        this.gpcPdtIdList = []
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    }
  }
}
</script>
